/**
 * Clerk can resume an in-progress auth flow on a hash route, e.g.
 * `/sign-in#/factor-one`, where `location.pathname` is still the bare root.
 * Shared by the route guard (which mounts the Clerk page for it) and the
 * page itself (which must not treat it as a fresh entry).
 */
export const hasNestedClerkHash = (hash: string): boolean => {
  if (!hash.startsWith('#/')) return false;
  const hashPath = hash.slice(2).split('?', 1)[0];
  return hashPath.replace(/\//g, '').length > 0;
};
